import { Component, OnInit } from '@angular/core';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PrimengImports } from '../../../shared/primeng-imports';
import { UserService } from '../../../service/user.service';

interface AllocationItem {
  portfolioName: string;
  amount: number;
  percentage: number;
}
interface RiskAssessment {
  label: string;
  riskScore: number;
  volatility: string;
  diversification: string;
}
@Component({
  selector: 'app-analytics-tab',
  imports: [LucideIconsModule,CommonModule, FormsModule,PrimengImports],
  templateUrl: './analytics-tab.component.html',
  styleUrl: './analytics-tab.component.css'
})
export class AnalyticsTabComponent implements OnInit {
  allocation: AllocationItem[] = [];
  risk: RiskAssessment | null = null;
  loading = false;
  error: string | null = null;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.fetchAnalytics();
  }

  fetchAnalytics(): void {
    this.loading = true;
    this.error = null;
    this.userService.getInvestmentAnalytics().subscribe({
      next: (res) => {
        if (res?.success) {
          this.allocation = res.data?.portfolioAllocation || [];
          this.risk = res.data?.riskAssessment || null;
        } else {
          this.error = 'Failed to load analytics.';
        }
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message || 'Failed to load analytics.';
        this.loading = false;
      }
    });
  }

  onExportReport(): void {
    // TODO: Implement export
    console.log('Exporting analytics report');
  }

  trackByName(index: number, item: AllocationItem): string {
    return item.portfolioName;
  }
}
